import {createSlice} from '@reduxjs/toolkit'

export const salesTargetInitialState = {
  formData: {
    activeDisplay: true,
    displayStartDate: '',
    displayEndDate: '',
  },
  displayContent: {
    en: {
      title: '',
      parentCategory: '',
      childCategory: '',
      exerpt: '',
      terms: '',
    },
  },
  targetName: '',
  ignoreSkuList: true,
  targetType: '',
  joinCampaignFlag: false,
  VATIncluded: false, //Exclude tax from goa is true then false
  roundPointsValue: 0,
  roundUpPointsFlag: true,
  offlineOrdersIncluded: false, // Include Offline Orders
  cepRefId: null,
  displayStartDate: '',
  displayEndDate: '',
  activeStartDate: '',
  activeEndDate: '',
  targetDeliveryDate: '',
  pointsDeliveryDate: '',
  pointsDisplay: 'Individual',
  awardPointsImmedFlag: false,
  ruleSet: {
    includeAllProductsByDefault: true,
    skipNonAssorted: false,
    rules: [
      {
        includedCategories: [],
        includedProductIds: [],
        excludedCategories: [],
        excludedProductIds: [],
      },
    ],
  },
  media: [
    {
      cepRefId: '7912062',
      id: null,
      index: '0',
      optIn: '1',
      title: 'abc',
      language: 'es_MX',
      filename: 'bg2.jpg',
      imageUrl: '',
    },
  ],
  childRuleSet: null,
  status: null,
  storeList: '',
  id: 1,
  preRequisiteTarget: ''

}

const salesTargetSlice = createSlice({
  name: 'salesTarget',
  initialState: salesTargetInitialState,
  reducers: {
    setSalesTargetDisplayContent: (state, action) => {
      return {
        ...state,
        displayContent: action.payload,
      }
    },
    resetSalesTarget: () => salesTargetInitialState,
    setSalesTargetDisplayContentMedia: (state, action) => {
      return {
        ...state,
        displayContentMedia: action.payload,
        media: [action.payload],
      }
    },
    setPrerequisiteTarget: (state, action) => {
      return {
        ...state,
        preRequisiteTarget: action.payload,
      }
    },
    resetSalesTargetDisplayContentMedia: state => {
      return {
        ...state,
        displayContentMedia: {
          title: '',
          imageId: '',
          imageUri: '',
          imageBase64: '',
        },
      }
    },
    setSalesTargetFormData: (state, action) => {
      return {
        ...state,
        ...action.payload,
        activeStartDate: action.payload.startDate,
        activeEndDate: action.payload.endDate,
        displayStartDate: action.payload.activeDisplay ? action.payload.startDate : action.payload.displayStartDate,
        displayEndDate: action.payload.activeDisplay ? action.payload.endDate : action.payload.displayEndDate,
        formData: action.payload,
        roundPointsValue: action.payload.roundOffValue,
        roundUpPointsFlag: action.payload.roundUpPoints ? true : false,
        VATIncluded: !action.payload.excludeTaxFromGoal ? true : false,
        joinCampaignFlag: action.payload.userNeedsToJoin ? true : false,
        offlineOrdersIncluded: action.payload.includeOfflineHours ? true : false,
        awardPointsImmedFlag: action.payload.awardPoint ? true : false,
        targetDeliveryDate: action.payload.targetEndDate,
      }
    },
    setSalesTargetSelectedCategory: (state, action) => {
      return {
        ...state,
        selectedCategory: action.payload,
      }
    },
    setRuleSet: (state, action) => {
      return {...state, ruleSet: action.payload.ruleSet}
    },
    resetRuleSet: state => {
      return {...state, ruleSet: salesTargetInitialState.ruleSet}
    },
    setStoreListUrl: (state, action) => {
      return {...state, storeList: action.payload}
    },
    // Add a product to the excluded list
    // First removes it from included list if present, then adds to excluded list if not already there
    addExcludedProduct: (state, action) => {
      const productId = action.payload
      state.includedProducts = state.includedProducts.filter(id => id !== productId)
      if (!state.excludedProducts.includes(productId)) {
        state.excludedProducts.push(productId)
      }
    },

    // Remove a product from the excluded list
    // Simply filters out the specified product ID from the excluded products array
    removeExcludedProduct: (state, action) => {
      state.excludedProducts = state.excludedProducts.filter(id => id !== action.payload)
    },

    // Add a product to the included list
    // First removes it from excluded list if present, then adds to included list if not already there
    addIncludedProduct: (state, action) => {
      const productId = action.payload
      state.excludedProducts = state.excludedProducts.filter(id => id !== productId)
      if (!state.includedProducts.includes(productId)) {
        state.includedProducts.push(productId)
      }
    },

    // Remove a product from the included list
    // Simply filters out the specified product ID from the included products array
    removeIncludedProduct: (state, action) => {
      state.includedProducts = state.includedProducts.filter(id => id !== action.payload)
    },
  },
})

export const {
  setSalesTargetDisplayContent,
  setSalesTargetDisplayContentMedia,
  resetSalesTargetDisplayContentMedia,
  resetSalesTarget,
  setSalesTargetFormData,
  setSalesTargetSelectedCategory,
  addExcludedProduct,
  removeExcludedProduct,
  addIncludedProduct,
  removeIncludedProduct,
  setRuleSet,
  setStoreListUrl,
  resetRuleSet,
  setPrerequisiteTarget

} = salesTargetSlice.actions

export const salesTargetSliceReducer = salesTargetSlice.reducer
